import React from 'react';
import { BookOpenIcon, CheckIcon, GiftIcon, GlobeIcon, LockIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { images, offerIncludes, offerStack } from '../../data/content';
export function Offer() {
  return <section id="offer" className="bg-navy-950 px-3 py-16 sm:px-4 sm:py-24" aria-labelledby="offer-title" data-id="element-258" data-mp="3575fwb5uai6c">
      <div className="mx-auto max-w-3xl" data-id="element-259" data-mp="3a4xe1mx2v0iz">
        <div className="text-center" data-id="element-260" data-mp="3f4a22azoqdn5">
          <p className="text-sm font-extrabold uppercase tracking-wider text-cta" data-id="element-261" data-mp="3f38q84auhn4d">Special introductory offer</p>
          <h2 id="offer-title" className="mt-3 text-[28px] font-black leading-[1.1] tracking-tight text-white text-balance sm:text-4xl lg:text-[44px]" data-id="element-262" data-mp="3jvs1gum28660">
            Here’s everything you’ll receive today
          </h2>
        </div>

        <img src={images.mockup} alt="Everything included in the Blueprint" className="mx-auto mt-8 w-full max-w-lg" data-id="element-263" data-mp="1ou8bmpizlxa" />

        <div className="mt-6 overflow-hidden rounded-3xl bg-white shadow-[0_20px_60px_rgba(0,0,0,0.35)]" data-id="element-264" data-mp="1km9lf1zd43t1">
          <ul className="divide-y divide-navy-900/10 px-4 sm:px-8" data-id="element-265" data-mp="1fktyt5hjdp8j">
            {offerStack.map(row => {
            const Icon = row.kind === 'volume' ? BookOpenIcon : GiftIcon;
            return <li key={row.label} className="flex items-center gap-3 py-4" data-id="element-266" data-mp="16njnjk4py03m">
                  <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${row.kind === 'volume' ? 'bg-navy-950 text-brand' : 'bg-cta text-navy-950'}`} data-id="element-267" data-mp="23aob9lxy1bs9">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-268" data-mp="1pkt50vqhh3i8" />
                  </span>
                  <span className="flex-1 text-[15px] font-bold leading-snug text-ink" data-id="element-269" data-mp="2mzys539fe2ry">{row.label}</span>
                  <span className="shrink-0 text-sm font-bold text-muted line-through decoration-danger decoration-2" data-id="element-270" data-mp="2i9iaf6yknuzs">
                    {row.value}
                  </span>
                </li>;
          })}
          </ul>

          <div className="flex items-center justify-between gap-3 bg-paper px-4 py-4 sm:px-8" data-id="element-271" data-mp="3638yr6dk1g1e">
            <span className="text-sm font-extrabold uppercase tracking-wide text-ink" data-id="element-272" data-mp="2scduy8hwxp4o">Total reference value</span>
            <span className="text-2xl font-black text-danger line-through decoration-2" data-id="element-273" data-mp="2wd7gwwbsotux">$237</span>
          </div>

          <div className="px-4 pb-6 pt-8 text-center sm:px-8 sm:pb-8" data-id="element-274" data-mp="2ih2hdti8qnyi">
            <p className="text-base font-bold text-muted sm:text-lg" data-id="element-275" data-mp="2nevk2ckc4zu1">Today, you can get the complete collection for just…</p>
            <p className="mt-2 flex items-baseline justify-center gap-2" data-id="element-276" data-mp="29ge26vh42hk1">
              <span className="text-[84px] font-black leading-none tracking-tight text-ink sm:text-[104px]" data-id="element-277" data-mp="2dgo9cbgn3e0h">$27</span>
              <span className="text-2xl font-black text-ink" data-id="element-278" data-mp="7npxehotjm25">USD</span>
            </p>
            <p className="mt-1 inline-block rounded-full bg-success px-4 py-1.5 text-sm font-black uppercase text-white" data-id="element-279" data-mp="bo009lhbdwcs">
              One-time payment · Save 88%
            </p>

            <ul className="mx-auto mt-6 max-w-sm space-y-2 text-left" data-id="element-280" data-mp="1s60c9y3a6py1">
              {offerIncludes.map(item => <li key={item} className="flex items-center gap-2.5" data-id="element-281" data-mp="25xydznunxjk6">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-success text-white" data-id="element-282" data-mp="215f4p330dal6">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-283" data-mp="2ft02qil10jm8" />
                  </span>
                  <span className="text-base font-semibold text-ink" data-id="element-284" data-mp="2av71m3ykyfst">{item}</span>
                </li>)}
            </ul>

            <CTAButton label="Yes! I want the complete Blueprint™ for $27" className="mt-7" data-id="element-285" data-mp="2jwelhh0cne3d" />

            <Countdown data-id="element-286" data-mp="uh8cuj53jhxf" />
            <ScarcityBar data-id="element-287" data-mp="ugf6vkdyowgc" />

            <div className="mt-5 flex items-start gap-3 rounded-2xl bg-paper p-4 text-left" data-id="element-288" data-mp="uhqk0atargk4">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-dark" aria-hidden="true" data-id="element-289" data-mp="pjf87ujfyvz9" />
              <p className="text-sm leading-relaxed text-ink" data-id="element-290" data-mp="rw0ovhhhnun0">
                <span className="font-extrabold" data-id="element-291" data-mp="vxum1fsh6gif">Automatic currency conversion.</span> Paying from outside the US? The
                price is converted to your local currency automatically at checkout by the payment provider.
              </p>
            </div>

            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-muted sm:text-sm" data-id="element-292" data-mp="15uh4jxxbwvha">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-293" data-mp="d7w4m92sfb24" />
              One-time payment · Digital product · Access to purchased files
            </p>
            <p className="mt-3 text-xs leading-relaxed text-muted/80" data-id="element-294" data-mp="i5ehubnu8cfx">
              Reference values are illustrative offer-positioning estimates, not verified retail prices.
            </p>
          </div>
        </div>
      </div>
    </section>;
}